import CryptoJS from 'crypto-js';

/**
 * Encrypts a given text using AES encryption algorithm.
 * @param {string} text - The text to be encrypted.
 * @param {string} secretKey - The secret key used for encryption. Must be in hexadecimal format.
 * @param {string} iv - The initialization vector (IV) used for encryption. Must be in hexadecimal format.
 * @returns {string} - The encrypted text in hexadecimal format.
 */
export const encrypt = (text: string, secretKey: string, iv: string) => {
  const value = CryptoJS.enc.Utf8.parse(text);
  const key = CryptoJS.enc.Hex.parse(secretKey);
  const ivParsed = CryptoJS.enc.Hex.parse(iv);
  const encrypted = CryptoJS.AES.encrypt(value, key, {
    iv: ivParsed,
    mode: CryptoJS.mode.CBC,
  });

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
};

/**
 * Decrypts a given encrypted text using AES decryption algorithm.
 * @param {string} text - The encrypted text to be decrypted. Must be in hexadecimal format.
 * @param {string} secretKey - The secret key used for decryption. Must be in hexadecimal format.
 * @param {string} iv - The initialization vector (IV) used for decryption. Must be in hexadecimal format.
 * @returns {string} - The decrypted text in UTF-8 format.
 */
export const decrypt = (text: string, secretKey: string, iv: string) => {
  const key = CryptoJS.enc.Hex.parse(secretKey);
  const ivParsed = CryptoJS.enc.Hex.parse(iv);

  const decrypted = CryptoJS.AES.decrypt(
    // @ts-ignore
    { ciphertext: CryptoJS.enc.Hex.parse(text) },
    key,
    { iv: ivParsed },
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};
